import axios from "axios";
import React, { useEffect, useState } from "react";
import { displayMessage } from "../../Utils/helper";
import { useLocation } from "react-router-dom";
import Breadcrumb from '../../components/common/Breadcrumb';
import Banner from "./Banner";
import Loader from "../common/Loader";
import AuthService from "../../services/AuthService";
import { Link } from "react-router-dom";


const { REACT_APP_API_BASE_URL } = process.env
const ComparisonTable = () => {
  const location = useLocation();
  const { workflow } = location.state || {}; // Accessing wf from the state
  const [selectedCity, setSelectedCity] = useState("");
  const [tableData, setTableData] = useState([]);
  const [cities, setCities] = useState([]);
  const [filteredCityData, setFilteredCityData] = useState([]);
  const [allWeeks, setAllWeeks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editedData, setEditedData] = useState([]);
  const workflow_id = workflow.workflow_id;

  useEffect(() => {
    getComparisonTable();
  }, []);
  const getComparisonTable = async () => {
    setIsLoading(true)
    try {
      const url = `${REACT_APP_API_BASE_URL}/get_fp?workflow_id=${workflow_id}`;
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Authorization" : AuthService.getAccessToken(),
          "access_token" : AuthService.getAccessToken()
        },
      });

      setTableData(response.data.data);

      // Extract unique cities and set them
      const uniqueCities = [
        ...new Set(response.data.data.map((entry) => entry.level5)),
      ];
      setCities(uniqueCities);
    } catch (error) {
      console.error("Error fetching workflows:", error.message);
      throw error;
    }
    setIsLoading(false)
    // setSelectedCity(value);
  };
 
  const filterCity = (value) => {
    setSelectedCity(value);

    // Filter data based on the selected level5
    const cityData = tableData.find((entry) => entry.level5 === value);
    if (cityData) {
      // Group data by SKU to remove duplicates
      const groupedData = Object.values(
        cityData.skus_data.reduce((acc, skuEntry) => {
          if (!acc[skuEntry.sku]) {
            acc[skuEntry.sku] = {
              sku: skuEntry.sku,
              data: [],
            };
          }
          acc[skuEntry.sku].data.push(skuEntry);
          return acc;
        }, {})
      );

      setFilteredCityData(groupedData);

      // Extract unique weeks
      const weeks = [
        ...new Set(cityData.skus_data.map((skuEntry) => skuEntry.week)),
      ].sort();
      setAllWeeks(weeks);

      // Initialize editable data
      const initialEditedData = groupedData.flatMap((skuGroup) =>
        skuGroup.data.map((entry) => ({ ...entry }))
      );
      setEditedData(initialEditedData);
    } else {
      setFilteredCityData([]);
      setAllWeeks([]);
      setEditedData([]);
    }
  };

  const handleForecastChange = (sku, week, value) => {
    setEditedData((prevData) =>
      prevData.map((entry) =>
        entry.sku === sku && entry.week === week
          ? { ...entry, forecast: value }
          : entry
      )
    );
  };

  const approveChanges = async () => {
    const payload = {
      workflow_id: workflow_id,
      city: selectedCity,
      skus_data: editedData.map((entry) => ({
        sku: entry.sku,
        week: entry.week,
        f_value: parseFloat(entry.forecast),
      })),
    };

    try {
      const url = `${REACT_APP_API_BASE_URL}/update_fcast_values`;
      const response = await axios.post(url, payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Authorization" : AuthService.getAccessToken(),
          "access_token" : AuthService.getAccessToken()
        },
      });

      if (response.status === 200) {
        displayMessage("success", "Changes approved and sent to backend successfully!");
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error("Error approving changes:", error.message);
      displayMessage("danger", "Failed to approve changes.");
    }
    getComparisonTable()
  };
  const pageName = "Comparison"

  return (
    <>
      <Breadcrumb List={[{ path:"/Dashboard", name:"Dasboard"},{path:"#", name:"Comparison"}]} />
      <Banner />

      <br />
      <h2 className="text-3xl font-bold mb-4 text-center">Comparison Table</h2>
      <br />
      <div style={{ marginTop: "10vh 0 10vh 0", padding: "5vh 0 5vh 0" }} className="mycontainer manage-workflow-box">
        {/* City Selection Dropdown */}
        <div style={{ padding: "0 10vw 0 10vw" }} className="my-4 flex flex-wrap items-center">
          <div className="w-full sm:w-1/2 mb-4 sm:mb-0">
            <h2>Workflow Name: {workflow.workflow_name}</h2>
            <br />
            <label
              htmlFor="city-select"
              className="mr-2 text-lg font-semibold text-gray-700"
            >
              Select City:
            </label>
            <select
              id="city-select"
              className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedCity}
              onChange={(e) => {
                filterCity(e.target.value);
              }}
            >
              <option value="">-- Select City --</option>
              {cities.map((city, index) => (
                <option key={index} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full sm:w-1/2 text-center">
           { workflow.approval_status.toUpperCase() !== 'APPROVED' ?
            <button
              onClick={approveChanges}
              className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-700"
            >
              Approve
            </button>
            :
                <button
                  to={'/indent'}
                  className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-700"
                  state={{ workflow}}
              >
                  {"Go to Indentation"}
              </button>
}
          </div>
        </div>





        <div className="mycontain">
          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-[#0C3C54] text-white">
                  {/* SKU / Week spanning two rows */}
                  <th
                    className="border border-gray-300 p-2 bg-[#0C3C54] text-white text-center w-[10%]"
                    rowSpan="2"
                  >
                    SKU / Week
                  </th>
                  {/* Weeks header */}
                  {allWeeks.map((week, index) => (
                    <th
                      key={index}
                      colSpan={2}
                      className="border border-gray-300 p-2 text-center w-[15%]"
                    >
                      {week}
                    </th>
                  ))}
                </tr>
                <tr className="bg-[#0C3C54] text-white">
                  {/* Sub-headers for Forecast Value and Predicted Value */}
                  {allWeeks.map((_, index) => (
                    <React.Fragment key={index}>
                      <th
                        className="border border-gray-300 p-2 text-center w-[7.5%]"
                      >
                        Forecast
                      </th>
                      <th
                        className="border border-gray-300 p-2 text-center w-[7.5%]"
                      >
                        Planned
                      </th>
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
              {
                isLoading ?
                  <span className="text-center">
                    <center style={{ marginTop: "10vh" }}><Loader size={'large'} /></center>
                  </span>
                  :
                  <>
                    <tbody>
                      {filteredCityData.map((skuGroup, index) => (
                        <tr key={index} className="hover:bg-gray-100">
                          <td className="border border-gray-300 p-2">{skuGroup.sku}</td>
                          {allWeeks.map((week) => {
                            const weekData = skuGroup.data.find(
                              (entry) => entry.week === week
                            );
                            return (
                              <>
                                <td
                                  key={`${skuGroup.sku}-forecast-${week}`}
                                  className="border border-gray-300 p-2"
                                >
                                  <input
                                    type="text"
                                    value={
                                      editedData.find(
                                        (entry) =>
                                          entry.sku === skuGroup.sku && entry.week === week
                                      )?.forecast || ""
                                    }
                                    onChange={(e) =>
                                      handleForecastChange(
                                        skuGroup.sku,
                                        week,
                                        e.target.value
                                      )
                                    }
                                    className="w-full border border-gray-300 rounded-md p-1"
                                  />
                                </td>
                                <td
                                  key={`${skuGroup.sku}-predicted-${week}`}
                                  className="border border-gray-300 p-2"
                                >
                                  {weekData && weekData.p_value !== null
                                    ? weekData.p_value
                                    : "-"}
                                </td>
                              </>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </>}
            </table>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

    </>
  );
};
export default ComparisonTable;
